import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { ToolTip } from '../AdminTeamCreation/styles';
import PropTypes from 'prop-types';

const HoverButton = ({
  title,
  showTooltip = true,
  onClick,
  svgPath,
  width,
  height,
  fillOpacity,
  disabled,
  backgroundColor,
  backgroundColorActive,
  activeColor,
  inActiveColor,
  marginLeft
}) => {
  const [isBtnActive, setIsBtnActive] = useState(false);

  const popover = () => (
    <Popover
      id="popover-basic"
      style={{
        width: 'auto',
        padding: '9px 14px',
        background: '#FFFFFF',
        border: '1px solid #0D4270',
        boxShadow: '0px 13px 28px rgba(0, 0, 0, 0.3)',
        borderRadius: '6px',
      }}
    >
      <div
        style={{
          fontFamily: 'Rubik',
          fontStyle: 'normal',
          fontWeight: '400',
          fontSize: '14px',
          lineHeight: '16px',
          color: '#0D4270',
          textAlign: 'center',
        }}
      >
        {title}
      </div>
    </Popover>
  );

  const buttonContent = (
    <div
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        marginLeft: marginLeft || '10px',
        background: !isBtnActive
          ? (disabled
            ? 'rgba(0, 92, 135, 0.1)'
            : backgroundColor || 'rgba(0, 92, 135, 0.05)')
          : backgroundColorActive || 'rgba(0, 92, 135, 1)',
      }}
      onClick={!disabled ? onClick : undefined}
      onMouseEnter={() => !disabled && setIsBtnActive(true)}
      onMouseLeave={() => !disabled && setIsBtnActive(false)}
    >
      <svg
        width={width || '24'}
        height={height || '24'}
        viewBox={`0 0 ${width || 24} ${height || 24}`}
        fill={!isBtnActive ? activeColor || '#F37A65' : inActiveColor || '#fff'}
        xmlns="http://www.w3.org/2000/svg"
        fillOpacity={
          !isBtnActive &&
          (fillOpacity ? fillOpacity : disabled ? '1' : '0.6')
        }
      >
        {svgPath}
      </svg>
    </div>
  );

  return (
    <ToolTip
      active={isBtnActive}
      style={{
        margin: '0px',
        width: 'auto',
        height: '100%',
        alignItems: 'center',
      }}
      fill={
        !isBtnActive
          ? disabled
            ? activeColor || '#fff'
            : activeColor || '#007AB1'
          : '#fff'
      }
      fillOpacity={!isBtnActive && '0.6'}
    >
      {showTooltip && title ? (
        <OverlayTrigger placement="bottom" overlay={popover()}>
          {buttonContent}
        </OverlayTrigger>
      ) : (
        buttonContent
      )}
    </ToolTip>
  );
};

HoverButton.propTypes = {
  title: PropTypes.string,
  showTooltip: PropTypes.bool,
  onClick: PropTypes.func,
  svgPath: PropTypes.element,
  width: PropTypes.string,
  height: PropTypes.string,
  fillOpacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  backgroundColor: PropTypes.string,
  backgroundColorActive: PropTypes.string,
  activeColor: PropTypes.string,
  inActiveColor: PropTypes.string,
  marginLeft: PropTypes.string,
};

export default HoverButton;
